export default __webpack_public_path__ + "static/media/photo--lg--81.3ebe31b7.jpg";